import { render, staticRenderFns } from "./IntentSort.vue?vue&type=template&id=05ff12a2&scoped=true&"
import script from "./IntentSort.vue?vue&type=script&lang=js&"
export * from "./IntentSort.vue?vue&type=script&lang=js&"
import style0 from "./IntentSort.vue?vue&type=style&index=0&id=05ff12a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ff12a2",
  null
  
)

export default component.exports